module.exports = __webpack_public_path__ + "static/18-dd7fe62ef26af2951ba81fd4682e3f97.png";